export function catalogSlug(value) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function catalogLocation(pathname, search = "") {
  const parts = pathname.split("/").filter(Boolean);
  const parameters = new URLSearchParams(search);
  const tabs = { internes: "internal", ichom: "sets", catalogue: "instruments" };
  return {
    tab: tabs[parts[1]] || tabs[parameters.get("onglet")] || "internal",
    slug: parts[0] === "protocoles-suivi" ? parts[1] : parts[2],
    questionnaireId: parts[1] === "internes" ? parts[2] : parameters.get("id"),
    variant: ["A", "B", "C"].includes(parameters.get("variante")) ? parameters.get("variante") : "A",
  };
}
